import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const BaseStyles = styled.div`
    min-width: 320px;
    overflow: hidden;
    background-image: url(${props => props.overlay});
    background-color: ${props => props.theme.bg_body};
    .align-left {
        text-align: left;
    }

    .align-center {
        text-align: center;
    }

    .align-right {
        text-align: right;
    }
    ul {
        list-style: disc;
        margin: 0 0 2em 0;
        padding-left: 1em;
        &.icons {
            list-style: none;
            cursor: default;
            padding-left: 0;
            li {
                display: inline-block;
                padding: 0 1.25em 0 0;
        
                &:last-child {
                    padding-right: 0;
                }
        
                .icon {
                    &:before {
                        font-size: 1.5em;
                    }
                }
            }
        }
        &.navlink {
            list-style: none;
            cursor: default;
            padding-left: 0;
            li {
                display: inline-block;
                padding: 0 1.25em 0 0;
        
                &:last-child {
                    padding-right: 0;
                }
        
                .icon {
                    &:before {
                        font-size: 1.5em;
                    }
                }
            }
        }
    }
    a {
        border-bottom: none;
        color: inherit;
        text-decoration: none;
        &:hover {
            border-bottom-color: transparent !important;
            color: ${props => props.theme.accent};
        }
    }
`
const Wrapper = (props) => (
    <BaseStyles>
        {props.children}
    </BaseStyles>
)

export { Wrapper } 



// WEBPACK FOOTER //
// ./src/components/wrapper.js